import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import bookeePaymentCapabilitiesV2Actions from 'store/resources/bookeePaymentCapabilitiesV2/actions'

const useGetUserPaymentCapabilities = () => {
  const dispatch = useDispatch()

  return useCallback(
    async (swipecastUserId) => {
      const endpoint = `/v2/client/users/${swipecastUserId}/payment_capabilities`
      return dispatch(bookeePaymentCapabilitiesV2Actions.resourceGetRequest(endpoint))
    },
    [dispatch]
  )
}

export default useGetUserPaymentCapabilities
